"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Support() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: copyRef,
    isVisible: copyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="18396" id="support-designed-around-business" className="bg-background text-foreground py-28 md:py-40 px-6 md:px-16">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {}
          <div ref={imageRef} data-index={0} className="lg:col-span-7 transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(16px)"
        }}>
            <div className="overflow-hidden shadow-lg" style={{
            borderRadius: "12px"
          }}>
              <div className="relative w-full" style={{
              aspectRatio: "4 / 5"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/business_support_team.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/business_support_team.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/business_support_team.webp-wvc-sizes" alt="Professional team providing dedicated business support and consulting" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
              </div>
            </div>
          </div>

          {}
          <div ref={copyRef} data-index={1} className="lg:col-span-5 lg:pt-20 transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]" style={{
          opacity: copyVisible ? 1 : 0,
          transform: copyVisible ? "translateY(0)" : "translateY(16px)",
          transitionDelay: "120ms"
        }}>
            <h2 className="font-default font-semibold text-foreground leading-[1.08]" style={{
            fontSize: "clamp(2.25rem, 4.2vw, 3.75rem)",
            letterSpacing: "-0.01em"
          }}>
              Built for <em className="font-default italic text-primary">growth</em>, driven by{" "}
              <em className="font-default italic text-primary">strategy</em>
            </h2>

            <div className="mt-8 space-y-6 text-foreground/85">
              <p className="font-default leading-[1.6]" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)"
            }}>
                Our support framework is designed to scale with your business. We provide 
                tailored solutions that anticipate your needs, ensuring your operations 
                run smoothly while you focus on your core objectives. No complexity, 
                just clear results.
              </p>
              <p className="font-default leading-[1.6]" style={{
              fontSize: "clamp(1.0625rem, 1.2vw, 1.1875rem)"
            }}>
                Every strategy is crafted by experts who understand the nuances of your 
                industry. We partner with you to build sustainable systems that evolve 
                alongside your company, turning challenges into opportunities for 
                long-term success.
              </p>
            </div>

            <div className="mt-10">
              <Link to="/WhoWeArePage" className="group inline-flex items-center gap-2 font-default text-foreground text-[0.9375rem] font-medium pb-1.5 border-b border-primary hover:border-b-2 transition-all duration-300">
                <span>Learn about our approach</span>
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}